/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export enum FuelControllerPumpAuthorizeConfirmationApiModel {
  SelectedNozzleUp = 'selected-nozzle-up',

  WithoutNozzleConfirmation = 'without-nozzle-confirmation'
}
